/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { createLazyLoadableSection } from '@zcode/lazy-loadable-section'
import type { ErrorBoundaryProps } from 'react-error-boundary'
import { logger } from '../../logger'

const onRenderError: ErrorBoundaryProps['onError'] = (error, info) => {
  logger.error('render error for MenuListContent lazy loadable section', info, error)
}

const onLoadingError = (error: unknown) => {
  logger.error('loading error for MenuListContent lazy loadable section', error)
}

const loadFn = /* #__LOADABLE__ */ async () =>
  await import(/* webpackChunkName: "MenuListContent" */ './MenuListContent')

const options = {
  errorFallback: () => null,

  loadingFallback: () => null,
  onRenderError,
  onLoadingError,
}

export const MenuListContentLoadable = createLazyLoadableSection(loadFn, options)
